import { robotoRegular, scarpaGray200, scarpaGray25, scarpaGray900, spanishViridian25, spanishViridian500 } from '@habitech/shared';
import styled from 'styled-components';

export const Wrapper = styled.div`
    font-family: ${robotoRegular};
    padding: 20px;
    margin-top: 20px;
    background: ${scarpaGray25};
    border-radius: 10px;
    border: 1px solid ${scarpaGray200};
    &.table {
        overflow: scroll hidden;
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }
    }
    label {
        margin-top: 10px;
    }
    input[data-id='testing_discount'] {
        text-align: right;
        &::placeholder {
            text-align: left;
        }
    }
    button[data-id='button-send-suggestions'] {
        margin: auto;
        margin-bottom: 20px;
    }
    button[data-id="test_user_type"] {
        width: 100%;
        margin-bottom: 20px;
    }
    .loading {
        height: 200px;
    }
    .button {
        align-content: end;
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
        overflow: unset;
        &.table {
            overflow: hidden;
        }
    }
`;

export const IconPercentage = styled.div`
    margin: 0 12px 0 0;
`;

export const WrapperIcon = styled.div`
    margin: 0px 0 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${scarpaGray900};
    font-weight: 500;
`;

export const InfoUser = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    color: ${scarpaGray900};
    font-weight: 500;
    font-size: 14px;
`;

export const InfoUserSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    background: ${scarpaGray25};
    border: 1px solid ${scarpaGray200};
    border-radius: 10px;
`;

export const InfoUserSectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1px solid ${scarpaGray200};
`;

/** Aviso (ámbar) de perfil incompleto: nombre/apellido requeridos para transacciones. */
export const ProfileNoticeAlert = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 10px;
    background: #fff8e1;
    border: 1px solid #f2c94c;
    color: #8a6d1b;
    font-size: 13px;
    font-weight: 500;
`;

export const InfoUserSectionTitle = styled.h3`
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: ${scarpaGray900};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const InfoUserItems = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;

    > .item-user-info {
        border: 1px solid ${scarpaGray200};
        border-radius: 10px;
        padding: 8px 12px;
        background: white;
        display: flex;
        align-items: center;
        gap: 6px;
        &[data-poc="true"] {
            background: ${spanishViridian25};
            border-color: ${spanishViridian500};
            color: ${spanishViridian500};
        }
    }
`;

/** Distintivo verde para canales de contacto verificados por OTP. */
export const VerifiedBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: ${spanishViridian500};
    font-size: 12px;
    font-weight: 600;
`;

export const ExpirationMonthsStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const ExpirationMonthGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const ExpirationMonthTitle = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: ${scarpaGray900};
    text-transform: capitalize;
`;
